import { render, staticRenderFns } from "./TopPensionFundsOpportunitiesView.vue?vue&type=template&id=21dc0026&scoped=true"
import script from "./TopPensionFundsOpportunitiesView.vue?vue&type=script&lang=js"
export * from "./TopPensionFundsOpportunitiesView.vue?vue&type=script&lang=js"
import style0 from "./TopPensionFundsOpportunitiesView.vue?vue&type=style&index=0&id=21dc0026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dc0026",
  null
  
)

export default component.exports